"use client";

/**
 * Root-layout error boundary. Unlike error.tsx this replaces the ENTIRE
 * document, so globals.css / fonts / CSS vars may not exist — everything
 * here is inline-styled and dependency-free on purpose.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#0a1628",
          color: "#e4e4ed",
          fontFamily: "system-ui, -apple-system, 'Segoe UI', sans-serif",
        }}
      >
        <div style={{ maxWidth: "560px", padding: "24px", textAlign: "center" }}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src="/brand/amalbryx-ab-wolf-square.png"
            alt=""
            width={144}
            height={144}
            style={{ height: "64px", width: "auto", marginBottom: "20px" }}
          />
          <div
            style={{
              fontSize: "11px",
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              color: "#3b82f6",
              marginBottom: "12px",
            }}
          >
            ERROR · 500 / ROOT{error?.digest ? ` · ${error.digest}` : ""}
          </div>
          <h1 style={{ fontSize: "32px", margin: "0 0 12px" }}>
            Something broke at the root.
          </h1>
          <p style={{ color: "rgba(228,228,237,0.7)", margin: "0 0 24px" }}>
            The studio still ships — this page just didn&apos;t.
          </p>
          <button
            type="button"
            onClick={() => reset()}
            style={{
              background: "#3b82f6",
              color: "#0a1628",
              border: "none",
              borderRadius: "6px",
              padding: "12px 20px",
              fontSize: "12px",
              letterSpacing: "0.14em",
              textTransform: "uppercase",
              cursor: "pointer",
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
